import React from 'react';
import { Box, Typography, styled, Divider, Grid, Button, Stack, Input, FormControl, InputAdornment, InputProps, MenuItem, InputLabel, Select, SelectProps } from '@mui/material';


export const PageContainer =  styled(Box)(({ theme }) => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    padding: theme.spacing(3),
    paddingBottom: 0,
    overflow: 'hidden',
    justifyItems: 'center',
}));

export const PageContent = styled(Box)(({ theme }) => ({
    flex: ''
}));

export const PageTitle = styled(Typography)(({ theme }) => ({
    display: 'flex',
    fontSize: '32px',
    fontWeight: 600,
    alignSelf: 'center',
    paddingBottom: theme.spacing(3),
}));

export const UnauthorizedText = styled(Typography)(({ theme }) => ({
    display: 'flex',
    flexGrow: 1,
    alignSelf: 'center',
}));